import React from 'react';
import bell from 'assets/Images/betaBell.svg';
import { FlexBox } from '@eltoro-ui/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLink } from '@fortawesome/pro-light-svg-icons';
import './BetaEndingInfo.scss';

const BetaEndingInfo = () => {
  return (
    <div className="beta-info-wrapper">
      <FlexBox UNSAFE_className="bell-info">
        <img src={bell} alt="ringing_bell" className="ringing_bell" />
        <FlexBox flexDirection="column">
          <h3 className="info-heading">Heads up! Our beta is ending on June 1, 2025.</h3>
          <FlexBox UNSAFE_className="info-desc" gap="4px">
            Thank you for helping us grow.
            <a
              href="https://beewohelp.zendesk.com/hc/en-us/articles/37137974080539-Important-Update-Beewo-Beta-Ending-Soon"
              target="_blank"
              className="external_link_notes"
              rel="noreferrer"
            >
              Important updates.
            </a>
          </FlexBox>
        </FlexBox>
      </FlexBox>
      <a
        href="https://docs.google.com/forms/d/e/1FAIpQLSfjBvpooETnt1d9XjMEt38nx-OOVsGTFf0iY4MpT1ZXTH-kUw/viewform"
        target="_blank"
        className="external_link"
        rel="noreferrer"
      >
        Help us Improve
        <FontAwesomeIcon icon={faExternalLink} />
      </a>
    </div>
  );
};

export default BetaEndingInfo;
